import type {
  ActionResult,
  LoginBody,
  MeResponse,
  ResetPasswordBody,
  SessionResponse,
  SessionUser,
  changePasswordBodySchema,
} from '@flux/shared';
import type { z } from 'zod';
import { apiFetch } from '@/lib/api/client.js';
import { setCsrfToken } from '@/lib/api/csrf.js';

/** `@flux/shared` exporte le schéma mais pas de type nommé pour ce DTO. */
export type ChangePasswordBody = z.infer<typeof changePasswordBodySchema>;

/** `/auth/*` — `02` §1. Fonctions pures, réutilisées par les hooks de `use-auth.ts` et les formulaires. */

export function login(body: LoginBody): Promise<SessionResponse> {
  return apiFetch<SessionResponse>('/auth/login', { method: 'POST', body });
}

export function logout(): Promise<ActionResult> {
  return apiFetch<ActionResult>('/auth/logout', { method: 'POST' });
}

export async function fetchCurrentUser(): Promise<SessionUser> {
  const me = await apiFetch<MeResponse>('/auth/me');
  // Réhydrate le jeton CSRF (onglet rouvert : cookie valide mais jeton perdu de
  // la mémoire) — le reste de l'app continue de consommer `SessionUser`.
  setCsrfToken(me.csrfToken);
  return me;
}

export function forgotPassword(email: string): Promise<ActionResult> {
  return apiFetch<ActionResult>('/auth/forgot-password', { method: 'POST', body: { email } });
}

export function resetPassword(body: ResetPasswordBody): Promise<ActionResult> {
  return apiFetch<ActionResult>('/auth/reset-password', { method: 'POST', body });
}

export function changePassword(body: ChangePasswordBody): Promise<ActionResult> {
  return apiFetch<ActionResult>('/auth/change-password', { method: 'POST', body });
}
